import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  ${'' /* background-color: #FAFAFA; */}
  margin: 0 235px 0 235px;
  padding: 18px 0;
  @media (max-width: 1000px) {
    margin: 0 30px;
  }
`;

export const Heading = styled.h1`
  margin: 0;
  font-family: NunitoSans-Bold;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 65.47px;
  letter-spacing: 1.5px;

  /* black */

  color: #000000;
  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 33px;
    text-align: center;
  }
`;

export const SubHeading = styled.h2`
  margin: 0;
  font-family: NunitoSans-SemiBold;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.5px;

  /* secondary Dark */

  color: #D67723;
`;

export const Line = styled.div`
  width:  100px;
  height: 3px;
  background-size: cover;
  background-image: url("/images/icons/Rectangle 36.png");
`;

export const ImageSwiper = styled.div`
width: 80%;
padding: 18px 0;
`;